// ***************************************
// Definition of game token GachaScreen
// ***************************************
import { inventoryController } from "../../../game_theme/flow_fb/flowController";
import { tbGame } from "../../engine/tbGame";
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentContainer } from "../../framework/components/ComponentContainer";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { ComponentSpine } from "../../framework/components/ComponentSpine";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { DialogSettings, PowerUpSettings } from "../../settings/Settings";
import { SoundManager } from "../../settings/SoundManager";
import { AngryAnalytics } from "../Analytics/Analytics";
import { s_gatcha_bg, s_black_square, s_titlesign, s_btn_arrow_blue, s_icon_back, s_icon_list, s_popup_darkblue_rect, s_btn_red, s_btn_green, s_btn_round_green_big, s_icon_movie, s_btn_round_grey_big, s_button_rectangle_white, s_buttonpowerbg, s_buttonpower_disabled } from "../AssetDefinitions/ImageDefinitions";
import { s_smokePuff } from "../AssetDefinitions/SpineDefinitions";
import { LoadingOverlay } from "./LoadingOverlay";
// The constructor for the GachaScreen game token. 
export var GachaScreen = function (onClose, fromEndScreen) {
    "use strict";
    // Properties used by the engine
    this.layer = 0;
    this.visible = true;
    this.active = true;
    // Your own properties
    this.height = 150;
    this.width = 1000;
    this.labelFont = DialogSettings.textFont;
    this.buttonFont = DialogSettings.buttonFont;
    this.onClose = onClose;
    this.showShowAdButton = true;
    this.fromEndScreen = fromEndScreen;
    this.refillText = "Do you want to refill ALL your power-ups?\nThis will replace any unused power-ups";
    this.powerupInventory = null;
    this.queuedChanges = this._createBlankQueue();
    // Add it to the game engine
    tbGame.addToken(this);
};
GachaScreen.prototype._createBlankQueue = function () {
    return [
        { timer: 0, delay: 250, active: false, complete: false },
        { timer: 0, delay: 250, active: false, complete: false },
        { timer: 0, delay: 250, active: false, complete: false },
        { timer: 0, delay: 250, active: false, complete: false },
        { timer: 0, delay: 250, active: false, complete: false }
    ];
};
GachaScreen.prototype.showSpines = function (num) {
    if (typeof (num) !== 'number') {
        for (var i = 0; i < this.spines.length; i++) {
            if (!this.spines[i].origPos) {
                this.spines[i].origPos = {
                    x: this.spines[i].spineClone.animation["transform"]["position"]["x"],
                    y: this.spines[i].spineClone.animation["transform"]["position"]["y"]
                };
            }
            var origX = this.spines[i].origPos.x;
            var origY = this.spines[i].origPos.y;
            if (origX === this.spines[i].spineClone.animation["transform"]["position"]["x"] && origX === this.spines[i].spineClone.animation["transform"]["position"]["y"]) {
                continue;
            }
            this.spines[i].spineClone.animation["transform"]["position"]["x"] = origX;
            this.spines[i].spineClone.animation["transform"]["position"]["y"] = origY;
        }
    }
    else {
        if (!this.spines[num].origPos) {
            this.spines[num].origPos = {
                x: this.spines[num].spineClone.animation["transform"]["position"]["x"],
                y: this.spines[num].spineClone.animation["transform"]["position"]["y"]
            };
        }
        var origX = this.spines[num].origPos.x;
        var origY = this.spines[num].origPos.y;
        if (origX === this.spines[num].spineClone.animation["transform"]["position"]["x"] && origX === this.spines[num].spineClone.animation["transform"]["position"]["y"]) {
            return;
        }
        this.spines[num].spineClone.animation["transform"]["position"]["x"] = origX;
        this.spines[num].spineClone.animation["transform"]["position"]["y"] = origY;
    }
};
GachaScreen.prototype.hideSpines = function (num) {
    if (typeof (num) !== 'number') {
        for (var i = 0; i < this.spines.length; i++) {
            this.spines[i].spineClone.animation["transform"]["position"]["x"] = -9999;
            this.spines[i].spineClone.animation["transform"]["position"]["y"] = -9999;
        }
    }
    else {
        this.spines[num].spineClone.animation["transform"]["position"]["x"] = -9999;
        this.spines[num].spineClone.animation["transform"]["position"]["y"] = -9999;
    }
};
// handleAdd is called when the token is (re-) added to the game. 
GachaScreen.prototype.handleAdd = function () {
    "use strict";
    var self = this;
    var textOffset = 16;
    this.dialog = new DialogBase({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
    this.background = new ComponentPicture({
        image: s_gatcha_bg,
        xScale: 2,
        yScale: 2,
        x: -tgfGraphics.areaWidth / 2,
        y: -tgfGraphics.areaHeight / 2
    });
    this.dialog.addComponent(this.background);
    this.inputBlocker = new ComponentButton({
        x: 0,
        y: 0,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0,
        image: s_black_square
    });
    this.dialog.addComponent(this.inputBlocker);
    this.titleBg = new ComponentPicture({
        image: s_titlesign,
        y: -tgfGraphics.areaHeight / 2 + 95
    });
    this.dialog.addComponent(this.titleBg);
    this.topLabel = new ComponentLabel({
        text: tgfDictionary.getText('YOUR_POWERUPS_HEADER'),
        font: this.labelFont,
        y: -tgfGraphics.areaHeight / 2 + 85
    });
    this.dialog.addComponent(this.topLabel);
    if (this.fromEndScreen) {
        this.lobbyButton = new ComponentButton({
            image: s_btn_arrow_blue,
            icon: s_icon_back,
            x: -(tgfGraphics.areaWidth / 2) + s_btn_arrow_blue.width + 20,
            y: (tgfGraphics.areaHeight / 2) - s_btn_arrow_blue.height + 0,
            iconPosition: "center"
        });
    }
    else {
        this.lobbyButton = new ComponentButton({
            image: s_btn_arrow_blue,
            icon: s_icon_list,
            x: -(tgfGraphics.areaWidth / 2) + s_btn_arrow_blue.width + 20,
            y: (tgfGraphics.areaHeight / 2) - s_btn_arrow_blue.height + 0,
            iconPosition: "center"
        });
    }
    this.lobbyButton.onClick = function () {
        SoundManager.playEffect(SoundManager.UI_STATE.BACK, SoundManager.UICollection, 0, false);
        self.goBack();
    };
    this.dialog.addComponent(this.lobbyButton);
    this.warningLabel = new ComponentLabel({
        text: tgfDictionary.getText('YOUR_POWERUPS_TEXT'),
        font: this.labelFont,
        y: 160
    });
    this.dialog.addComponent(this.warningLabel);
    // Confirmation popup
    this.popupContainer = new ComponentContainer({
        y: -100
    });
    this.dialog.addComponent(this.popupContainer);
    this.popupBackground = new ComponentPicture({
        image: s_popup_darkblue_rect,
        x: -this.width / 2, y: -this.height / 2,
        createFromSlices: true,
        sliceMargins: 30,
        height: this.height, width: this.width
    });
    this.popupContainer.addComponent(this.popupBackground);
    this.popupLabel = new ComponentLabel({
        text: this.refillText,
        font: this.labelFont,
        y: -5,
        align: "center"
    });
    this.popupContainer.addComponent(this.popupLabel);
    this.confirmationButtonContainer = new ComponentContainer({
        y: this.height / 2 + 60
    });
    this.popupContainer.addComponent(this.confirmationButtonContainer);
    this.noButton = new ComponentButton({
        image: s_btn_red,
        text: "NO",
        fontUp: this.buttonFont,
        x: -this.width / 3.9,
        marginTop: textOffset,
        xScale: 1,
        yScale: 1,
        onClick: function () {
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            self._hideConfirmationPopup();
        }
    });
    this.confirmationButtonContainer.addComponent(this.noButton);
    this.yesButton = new ComponentButton({
        image: s_btn_green,
        text: "YES",
        fontUp: this.buttonFont,
        x: this.width / 3.9,
        marginTop: textOffset,
        xScale: 1,
        yScale: 1,
        onClick: function () {
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            self._showAdButtonPressed();
        }
    });
    this.confirmationButtonContainer.addComponent(this.yesButton);
    this.finishButton = new ComponentButton({
        image: s_btn_green,
        text: tgfDictionary.getText('BTN_OK'),
        fontUp: this.buttonFont,
        y: this.height / 2 + 60,
        marginTop: textOffset,
        x: 0,
        onClick: function () {
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            self._hideConfirmationPopup();
        }
    });
    this.popupContainer.addComponent(this.finishButton);
    // Big show ad button
    var halfWidth = s_btn_round_green_big.width / 2;
    var halfHeight = s_btn_round_green_big.height / 2;
    this.showAdButton = new ComponentButton({
        image: s_btn_round_green_big,
        xScale: 1.5,
        yScale: 1.5,
        x: halfWidth,
        y: halfHeight,
        onClick: function () {
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            AngryAnalytics.reportUXButton("rewarded_ad_button");
            //self._showConfirmationPopup();
            self._showAdButtonPressed();
        }
    });
    this.dialog.addComponent(this.showAdButton);
    this.showAdIcon = new ComponentPicture({
        image: s_icon_movie,
        x: -halfWidth,
        y: -halfHeight
    });
    this.showAdButton.addComponent(this.showAdIcon);
    this.disabledAdButton = new ComponentButton({
        image: s_btn_round_grey_big,
        xScale: 1.5,
        yScale: 1.5,
        x: halfWidth,
        y: halfHeight,
        text: "0:00",
        fontUp: this.labelFont
    });
    this.dialog.addComponent(this.disabledAdButton);
    this.initPowerups();
    this.dialog.show();
    this.reloadPowerups(false);
    for (var i = 0; i < this.spines.length; i++) {
        this.spines[i].hide();
    }
    this.popupContainer.hide();
    var remainingTime = inventoryController.getCooldown();
    if (remainingTime > 0) {
        this.showAdButton.hide();
    }
    else {
        this.disabledAdButton.hide();
    }
    this.loader = new LoadingOverlay({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
};
GachaScreen.prototype.updateTimer = function () {
    if (!this.disabledAdButton) {
        return;
    }
    var remainingTime = inventoryController.getCooldown();
    if (remainingTime > 0) {
        if (this.showAdButton.isVisible) {
            this.showAdButton.hide();
        }
        if (!this.disabledAdButton.isVisible) {
            this.disabledAdButton.show();
            this.disabledAdButton.activate();
        }
        var cdText = inventoryController.getCooldownText();
        if (this.disabledAdButton.text != cdText) {
            this.disabledAdButton.setText(cdText);
        }
    }
    else if (!this.showAdButton.isVisible && this.disabledAdButton.isVisible) {
        this.showAdButton.show();
        this.showAdButton.activate();
        this.disabledAdButton.hide();
    }
};
GachaScreen.prototype.initPowerups = function () {
    this.powerupBar = new ComponentPicture({
        image: s_button_rectangle_white,
        xScale: 1.8,
        yScale: 1.2,
        y: 270
    });
    this.powerupImages = [];
    this.powerupBackgrounds = [];
    this.whiteSpheres = [];
    this.spines = [];
    var powerups = inventoryController.getPowerUpSlots();
    var spacing = 130;
    var leftY = -spacing * ((powerups.length - 1) / 2);
    for (var i = 0; i < powerups.length; i++) {
        this.whiteSpheres[i] = new ComponentPicture({
            image: s_buttonpowerbg,
            x: leftY + spacing * i,
            xScale: 1.07,
            yScale: 1.07
        });
        this.powerupBackgrounds[i] = new ComponentPicture({
            xScale: 1.1,
            yScale: 1.1
        });
        this.whiteSpheres[i].addComponent(this.powerupBackgrounds[i]);
        this.powerupImages[i] = new ComponentPicture({
            xScale: 1.1,
            yScale: 1.1
        });
        this.whiteSpheres[i].addComponent(this.powerupImages[i]);
        this.spines[i] = new ComponentSpine({
            x: 0,
            y: 0,
            spineAnimation: s_smokePuff,
            repeat: false
        });
        this.powerupImages[i].addComponent(this.spines[i]);
        this.powerupBar.addComponent(this.whiteSpheres[i]);
    }
    this.dialog.addComponent(this.powerupBar);
};
GachaScreen.prototype.reloadPowerups = function (playAnimation) {
    "use strict";
    var powerups = inventoryController.getPowerUpSlots();
    var self = this;
    for (var i = 0; i < powerups.length; i++) {
        if (playAnimation) {
            setTimeout(function (index) {
                self._reloadPowerup(index, true, powerups);
            }, 250 * i, i);
        }
        else {
            this._reloadPowerup(i, false, powerups);
        }
    }
};
GachaScreen.prototype._reloadPowerup = function (i, playAnimation, powerups) {
    if (powerups[i].powerUp != -1) {
        if (!playAnimation) {
            this.powerupBackgrounds[i].changeImage(PowerUpSettings.options[powerups[i].powerUp].bgImg);
            this.powerupImages[i].changeImage(PowerUpSettings.options[powerups[i].powerUp].image);
        }
        if (!this.powerupImages[i].originalPosition) {
            this.powerupImages[i].originalPosition = { x: this.powerupImages[i].x, y: this.powerupImages[i].y };
        }
        // Uncomment this if the icon offsets -Sam
        //this.powerupImages[i].x = (this.powerupImages[i].originalPosition.x + PowerUpSettings.options[powerups[i].powerUp].iconOffset.x);
        //this.powerupImages[i].y = (this.powerupImages[i].originalPosition.y + PowerUpSettings.options[powerups[i].powerUp].iconOffset.y);
        var _this = this;
        if (playAnimation) {
            this.spines[i].setAnimation(PowerUpSettings.options[powerups[i].powerUp].smokePuff, function (self) {
                //self.hide();
                _this.hideSpines(i);
            });
            if (this.queuedChanges[i].active == false) {
                this.queuedChanges[i].active = true;
            }
            this.spines[i].bringToFront();
            //this.spines[i].show();
            this.spines[i].activate();
            this.showSpines(i);
        }
    }
    else {
        this.powerupBackgrounds[i].changeImage(s_buttonpower_disabled);
    }
};
GachaScreen.prototype._showAdButtonPressed = function () {
    "use strict";
    var self = this;
    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
    self.onAdSuccess();
};
GachaScreen.prototype.onAdSuccess = function () {
    if (inventoryController.getCooldown() <= 0) {
        this.showAdWatched();
        this.queuedChanges = this._createBlankQueue();
        this.powerupInventory = inventoryController.getPowerUpSlots();
        inventoryController.resetCooldown();
        inventoryController.unlockAllPowerUps();
        this.reloadPowerups(true);
    }
};
GachaScreen.prototype._showConfirmationPopup = function () {
    this.showAdButton.hide();
    // this.popupContainer.show();
    // this.popupContainer.activate();
    // this.finishButton.hide();
    this.showShowAdButton = false;
};
GachaScreen.prototype._hideConfirmationPopup = function () {
    this.showAdButton.show();
    this.showAdButton.activate();
    // this.popupContainer.hide();
    this.popupLabel.setText(this.refillText);
    this.showShowAdButton = true;
};
GachaScreen.prototype.showAdWatched = function () {
    this.confirmationButtonContainer.hide();
    // this.finishButton.show();
    // this.finishButton.activate();
    this.popupLabel.setText("Five new power-ups are ready to be used!");
};
GachaScreen.prototype.goBack = function () {
    tbGame.removeToken(this);
};
GachaScreen.prototype.toggleInput = function (enable) {
    if (!this.dialog) {
        return;
    }
    if (enable) {
        this.lobbyButton.activate();
        if (this.confirmationButtonContainer.isVisible) {
            this.confirmationButtonContainer.activate();
        }
        if (this.finishButton.isVisible) {
            this.finishButton.activate();
        }
        if (this.showAdButton.isVisible) {
            this.showAdButton.activate();
        }
    }
    else {
        this.lobbyButton.deactivate();
        if (this.confirmationButtonContainer.isVisible) {
            this.confirmationButtonContainer.deactivate();
        }
        if (this.finishButton.isVisible) {
            this.finishButton.deactivate();
        }
        if (this.showAdButton.isVisible) {
            this.showAdButton.deactivate();
        }
    }
};
// handleRemove is called when the token is removed from the game.
GachaScreen.prototype.handleRemove = function () {
    "use strict";
    if (this.onClose) {
        this.onClose();
    }
    if (this.dialog) {
        this.dialog.hide();
        this.dialog.free();
        this.dialog = null;
    }
    if (this.loader) {
        this.loader.hide();
        this.loader.free();
        this.loader = null;
    }
};
// handleBeginStep is called each step before processing other events.
GachaScreen.prototype.handleBeginStep = function (timePassed) {
    "use strict";
    if (this.showShowAdButton) {
        this.updateTimer();
    }
};
// handleTouchDown is called when a touch is started or if a mouse button is pressed.
GachaScreen.prototype.handleTouchDown = function (finger, x, y) {
    "use strict";
};
// handleTouchUp is called when a touch is ended or if a mouse button is released.
GachaScreen.prototype.handleTouchUp = function (finger, x, y) {
    "use strict";
};
// handleAlarm is called if a global alarm is reached.
GachaScreen.prototype.handleAlarm = function (alarm) {
    "use strict";
};
// handleSpecial is called if a special or user-defined event happens.
GachaScreen.prototype.handleSpecial = function (id, args) {
    "use strict";
};
// handleEndStep is called each step after processing other events (before draw).
GachaScreen.prototype.handleEndStep = function (timePassed) {
    "use strict";
    var completeCounter = 0;
    for (var i = 0; i < this.queuedChanges.length; i++) {
        var e = this.queuedChanges[i];
        if (e.active === true) {
            e.timer += timePassed;
            if (e.timer >= e.delay) {
                this.powerupBackgrounds[i].changeImage(PowerUpSettings.options[this.powerupInventory[i].powerUp].bgImg);
                this.powerupImages[i].changeImage(PowerUpSettings.options[this.powerupInventory[i].powerUp].image);
                e.active = false;
                e.complete = true;
                this.spines[i].bringToFront();
            }
        }
        if (e.complete === true)
            completeCounter++;
    }
};
// handleDraw is called at the end of a step to draw the token.
GachaScreen.prototype.handleDraw = function () {
    "use strict";
};
